import { KlaviyoClient } from './klaviyo.client';
import { Actions, ofActionSuccessful, Store } from '@ngxs/store';
import { CheckoutStartedEvent } from '@app/features/checkout/state/checkout.actions';
import { CartState } from '@app/state/cart/cart.state';
import { Cart } from '@api/models/cart';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';
import { SalesArticleState } from '@app/state/sales-article/sales-articles.state';
import { AccountState } from '@app/state/account/account.state';
import { Login } from '@app/state/account/account.actions';

@Injectable({
  providedIn: 'root'
})
export class KlaviyoService {
  constructor(
    public klaviyoClient: KlaviyoClient,
    public actions$: Actions,
    public store: Store
  ) {}

  startTracking() {
    this.setupIdentify();
    this.setupCheckoutTracking();
    this.setupSalesArticleViewedTracking();
  }

  setupIdentify() {
    this.actions$.pipe(ofActionSuccessful(Login)).subscribe(() => {
      const email = this.store.selectSnapshot(AccountState.selectEmail);
      this.klaviyoClient.identify({ $email: email });
    });
  }

  setupCheckoutTracking() {
    this.actions$.pipe(ofActionSuccessful(CheckoutStartedEvent)).subscribe(() => {
      const email = this.store.selectSnapshot(AccountState.selectEmail);
      const cart = this.store.selectSnapshot(CartState.selectCart);
      this.klaviyoClient.track(
        'Started Checkout',
        { $email: email },
        { $cartData: KlaviyoService.constructCartData(cart, email) }
      );
    });
  }

  setupSalesArticleViewedTracking() {
    this.store
      .select(SalesArticleState.selectSalesArticle)
      .pipe(filter(Boolean))
      .subscribe((salesArticle) => {
        const email = this.store.selectSnapshot(AccountState.selectEmail);
        this.klaviyoClient.track('Viewed Product', { $email: email }, { $viewedProduct: salesArticle });
      });
  }

  setupCartTracking() {
    // this.actions$.pipe(ofActionSuccessful(AddProductToCart)).subscribe(() => {
    //             const email = this.store.selectSnapshot(AccountState.selectEmail);
    //             const cart = this.store.selectSnapshot(CartState.selectCart);
    //             this.klaviyoClient.track(
    //                     'Added to Cart',
    //                     {$email: email},
    //                     {$data: KlaviyoService.constructCartData(cart, email)}
    //             );
    //         }
    // );
  }

  static constructCartData(cart: Cart, email: string) {
    return {
      user: email,
      cartId: cart.id,
      $value: cart.totalPrice,
      cartLines: cart.cartLines.map((val) => {
        return {
          price: val.linePrice,
          quantity: val.quantity,
          unitPrice: val.unitPriceAtQuantity,
          savinds: val.savings,
          suggestedReailtPrice: val.salesArticle.suggestedRetailPrice,
          thumbnail: val.salesArticle.thumbnailUrl,
          salesArticleName: val.salesArticle.name,
          salesArticleUrlId: val.salesArticle.urlId,
          salesArticleUrlName: val.salesArticle.urlName
        };
      })
    };
  }
}
